const backendUrl = process.env.REACT_APP_BACKEND_URL;

if (!backendUrl) {
  throw new Error(
    'REACT_APP_BACKEND_URL is not defined. Configure it in .env, .env.production, or the hosting build environment.'
  );
}

/** Axios base URL including /api (no trailing slash on host). */
export const API_BASE_URL = `${String(backendUrl).replace(/\/$/, '')}/api`;
